import type { HealthResponse } from '../contracts/common';
import {
  normalizeBackendEvent,
  type ChaocEvent,
  type PublicEventResponse,
  type PublicEventsResponse,
} from '../contracts/events';
import type { PublicSourcesResponse, SourceRegistryCard } from '../contracts/sources';
import type { ApiClient } from './client';

export class PublicApi {
  constructor(private readonly client: ApiClient) {}

  async health(signal?: AbortSignal): Promise<HealthResponse> {
    return this.client.get<HealthResponse>('/health', signal);
  }

  async listEvents(signal?: AbortSignal): Promise<ChaocEvent[]> {
    const response = await this.client.get<PublicEventsResponse>('/api/public/events', signal);
    return response.events.map(normalizeBackendEvent);
  }

  async getEvent(id: string, signal?: AbortSignal): Promise<PublicEventResponse> {
    return this.client.get<PublicEventResponse>(`/api/public/events/${encodeURIComponent(id)}`, signal);
  }

  async listSources(signal?: AbortSignal): Promise<SourceRegistryCard[]> {
    const response = await this.client.get<PublicSourcesResponse>('/api/public/sources', signal);
    return response.sources;
  }
}
